import { TransferCreditsProgressState } from './../progression/transfer_credits_progress_state';
import { IProgression } from 'utility-js-progression';
import { ICommand, IDefineCommand, IDatasource, IQueryMediator, key } from 'core-ts-types';

angular.module('capability-ng-transfer')
  .factory('updateTransferProgressCommand', (
    ngTransferCreditsProgressState: TransferCreditsProgressState,
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    $http: ng.IHttpService): ICommand => {
    return defineCommand('updateTransferProgressCommand', function updateTransferProgress(deferred: ng.IDeferred<void>, stateKey: key): void {

      $http({
        method: 'PATCH',
        url: 'student/profile/',
        data: {
          progress: String(stateKey)
        }
      })
      .then((response: ng.IHttpPromiseCallbackArg<any>): void => {

        ngTransferCreditsProgressState.setLastVisitedState(stateKey);

      })
      .catch((error: ng.IHttpPromiseCallbackArg<any>): any => {
        return error.data;
      });

    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/update_transfer_progress_command.ts